import { Element } from 'types';
import { LA2_ID } from 'config';

const SEPARATOR = '_';
export const isDlcElement = (id: Element['id']) => id.includes(SEPARATOR);
export const isFromDlc = (id: Element['id'], dlcId: string) => {
  if (dlcId === LA2_ID) {
    return !isDlcElement(id);
  }

  return isDlcElement(id) && id.includes(dlcId);
};
